module.exports = __webpack_public_path__ + "images/topbrands-icon.39ee7cea6ede000b936c98f4234cf50f.svg";